import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useAppDispatch } from '../../../../../../store/hooks';
import { ItemLabelModel } from '../../../../../shared/components/dropdown/models/dropdown-props.model';
import { FeaturedEnum } from '../../../../../shared/enums/featured.enum';
import { mapFeatureEnumToItemLabelModel } from '../../../../../shared/utils/mapping/mapping.utils';
import { optionEquality } from '../../../../../shared/utils/option-equality/option-equality.util';
import { filterAppsByIsFeatured } from '../../../../store/slices/apps.slice';
import { AppsFilterProps } from '../../types/apps-filter-props.type';
import { withAppsFilterValues } from '../with-apps-filter-values';

const FeaturedDropdown: FunctionComponent<AppsFilterProps> = (
  props: PropsWithChildren<AppsFilterProps>
): ReactElement => {
  const dispatch = useAppDispatch();

  const {
    setFieldValue,
    selectedAppFilters: { isFeatured },
  } = props;

  const optionsFeatured = [FeaturedEnum.Yes, FeaturedEnum.No].map(
    mapFeatureEnumToItemLabelModel
  );

  return (
    <FormControl
      key="featured-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="is-featured"
        freeSolo={false}
        multiple={false}
        options={optionsFeatured}
        isOptionEqualToValue={optionEquality}
        value={
          isFeatured !== null && isFeatured !== undefined
            ? optionsFeatured[isFeatured ? 0 : 1]
            : null
        }
        onChange={(event, value) => {
          const val = value as ItemLabelModel;
          setFieldValue('isFeatured', val);
          dispatch(
            filterAppsByIsFeatured(val !== null ? !!val?.id : undefined)
          );
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="isFeatured"
            label="Featured"
            name="isFeatured"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withAppsFilterValues(FeaturedDropdown);
